<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header small-header">
        <h1>Survey Saved, Incompleted</h1>
      </div>
      <div class="page-form-content">
        <div class="form-description">
          <p>Your input for your <span class="text-success">{{ surveyTypeName }}</span> is saved<br /> but not yet complete.</p>
          <p>You will need to log back in to complete your clinical information before going to Labcorp for your blood testing.</p>
        </div>
        <b-form-group class="form-buttons">
          <b-btn variant="light" to="/">Home</b-btn>
          <b-btn variant="success" to="/reports">My Reports</b-btn>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  import productType from 'enums/product-type';

  export default {
    computed: {
      ...mapState("survey", ["survey"]),

      surveyTypeName() { return (this.survey.type == productType.InitialCRAAPOB || this.survey.type == productType.InitialCRALDLP) ? "Cardiometabolic Risk Assessment" : "Diabetic Risk Assessment" }
    },

    methods: {
      ...mapActions("user", ["getCurrentUser"])
    },

    async created() {
      await this.getCurrentUser();
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/mixins';

  .page {
    @include retina('/png/table-coffee.png');
  }
</style>